import React, { useState } from "react";
import {
  Box,
  Paper,
} from "@mui/material";
import DriverDetails from "./driverDetails.tsx/DriverDetails";
import DriverDocs from "./driverDocuments/DriverDocs";
import { addDriver } from "../../../services/dashboard";
import DriverSubmission from "./driver-submission/DriverSubmission";
import { useToast } from "../../../hooks/useToast";

type FileState = {
  driver_license: File | null;
  driver_pdp: File | null;
};

export default function AddDriver({onSubmit}:any) {
  const [step, setStep] = useState(1);
  const [documents, setDocuments] = useState<FileState>({
    driver_license: null,
    driver_pdp: null,
  });
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    licenseCode: "",
    phoneNumber: "",
    residentialAddress: "",
    workShift: "",
    assignedVehicleNumber: "",
    assignedVehicleType: "",
    branchId: "",
    branchLocation: "",
    gender: "",
    licenseIssueDate: "",
    licenseExpiryDate: "",
    hasPdp: "true",
  });

  const {showInfoToast} = useToast()

  const handleSubmit = async () => {
    try {
      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        password: formData.password || undefined,
        phoneNumber: formData.phoneNumber,
        residentialAddress: formData.residentialAddress,
        licenseCode: formData.licenseCode,
        licenseIssueDate: formData.licenseIssueDate,
        licenseExpiryDate: formData.licenseExpiryDate,
        workShift: formData.workShift,
        assignedVehicleNumber: formData.assignedVehicleNumber,
        assignedVehicleType: formData.assignedVehicleType,
        branchId: formData.branchId || undefined,
        branchLocation: formData.branchLocation,
        gender: formData.gender,
        hasPdp: formData.hasPdp === "true",
      };

      const formDataToSend = new FormData();
      const driver = new Blob([JSON.stringify(payload)], {
        type: "application/json",
      });
      formDataToSend.append("driver", driver);

      // 👇 files
      if (documents.driver_license) {
        formDataToSend.append("driver_license", documents.driver_license);
      }

      if (formData.hasPdp === "true" && documents.driver_pdp) {
        formDataToSend.append("driver_pdp", documents.driver_pdp);
      }

      const response = await addDriver(formDataToSend);
      if (response?.status === 200 || response?.status === 201) {
        setStep(3)
      } else {
        showInfoToast(response?.data?.message || "Unable to add driver");
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return (
          <DriverDetails
            setStep={setStep}
            setFormData={setFormData}
            formData={formData}
          />
        );
      case 2:
        return (
          <DriverDocs
            setStep={setStep}
            setFormData={setFormData}
            formData={formData}
            onSubmit={handleSubmit}
            setDocuments={setDocuments}
            documents={documents}
          />
        );
      case 3:
        return <DriverSubmission onHomeClick={onSubmit}/>;

      default:
        return null;
    }
  };

  return <Box>
      <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 3,
            backgroundColor: "#fff",
          }}
        >
           {renderStepContent()}
        </Paper>
   </Box>;
}
